export const formatCurrency = (value, options) =>
  value?.toLocaleString("en-US", {
    ...(options?.currencyDisplay !== "none" && {
      style: "currency",
      currency: "USD",
      currencyDisplay: options?.currencyDisplay || "symbol",
    }),
    maximumFractionDigits: options?.digits || 0,
    minimumFractionDigits: options?.digits || 0,
  });

export const calculatePriceAfterPromotion = (price, percentOff = 0, credit = 0) => {
  // promotion logic is to apply percentage discount first then fixed credit
  // min payment amount is $0.01 for sanity
  const calculatedPrice = Number((price * (1 - percentOff / 100) - credit).toFixed(2));
  return Math.max(calculatedPrice, 0.01);
};